import axiosInstance from '../../../core/api/axios';
import {
  FinishSimulationResponse,
  LiveSimulation,
  LiveSimulationFeedback,
  LiveSimulationItemDto,
  SaveAnswerRequest,
  SaveAnswerResponse,
  StartSimulationResponse,
} from '../models/LiveSimulationsDto.model';

export async function getLiveSimulations(origin: string): Promise<LiveSimulationItemDto[]> {
  try {
    const response = await axiosInstance.get(`/live-simulations?origin=${origin}`);

    return response.data;
  } catch (e: any) {
    throw new Error(e);
  }
}

export async function getLiveSimulationBySlug(
  slug: string
): Promise<LiveSimulationItemDto> {
  try {
    const response = await axiosInstance.get(`/live-simulations/${slug}`);

    return response.data;
  } catch (e: any) {
    throw new Error(e);
  }
}

export async function loadLiveSimulation(
  slug: string
): Promise<LiveSimulation> {
  try {
    const response = await axiosInstance.get(`/live-simulations/${slug}/load`);

    return response.data;
  } catch (e: any) {
    throw new Error(e);
  }
}

export async function startLiveSimulation(
  slug: string
): Promise<StartSimulationResponse> {
  try {
    const response = await axiosInstance.post(`/live-simulations/${slug}`);

    return response.data;
  } catch (e: any) {
    throw new Error(e);
  }
}

export async function saveAnswer({
  question,
  answer,
  historyId,
}: SaveAnswerRequest): Promise<SaveAnswerResponse> {
  try {
    const response = await axiosInstance.put(`/live-simulations/${historyId}`, {
      question,
      answer,
    });

    return response.data;
  } catch (e: any) {
    throw new Error(e);
  }
}

export async function finishLiveSimulation(
  historyId: string
): Promise<FinishSimulationResponse> {
  try {
    const response = await axiosInstance.post(
      `/live-simulations/${historyId}/finish`
    );

    return response.data;
  } catch (e: any) {
    throw new Error(e);
  }
}

export async function getLiveSimulationFeedback(
  slug: string
): Promise<LiveSimulationFeedback> {
  try {
    const response = await axiosInstance.get(
      `/live-simulations/${slug}/feedback`
    );

    return response.data;
  } catch (e: any) {
    throw new Error(e);
  }
}
